export default __webpack_public_path__ + "static/media/agate_agnidus_a_sliver.ebc11490.png";